import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descriptionbox-nav-box fade">Reviews (122)</div>
      </div>
      <div className="descriptionbox-description">
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum officia sunt omnis eos ducimus nostrum illum voluptatibus sequi laudantium? Harum beatae, natus quidem illum modi ipsa ab provident! Placeat similique necessitatibus magni repellendus, ducimus odio? Itaque laudantium, ut reiciendis, veniam similique consequatur eligendi omnis corrupti consectetur incidunt voluptatibus impedit asperiores.</p>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis ipsa aliquid voluptatibus, sunt officia quod sapiente quos cumque fugiat, quasi quam perferendis. Beatae praesentium temporibus esse odit sit, quia sed, possimus blanditiis quis dolorem autem nihil et provident laboriosam? Nam quas eum inventore placeat velit reiciendis natus recusandae ipsam soluta.</p>
      </div>
    </div>
  )
}

export default DescriptionBox
